import { sizeFields } from './size-fields'
import { shippingFields } from './shipping-fields'
import { priceFields } from './price-fields'
import { storeFields } from './store-fields'
import { variationsFields } from './variations-fields'
import { tagsFields } from './tags-fields'
import { categoriesFields } from './categories-fields'

export const productsFields = /* GraphQL */ `
  fragment productsFields on Product {
    id
    used
    path
    can_be_added_to_bundle
    photo {
      image_public_id
    }
    title {
      name
    }
    brand {
      displayable_name
    }
    price {
      ...priceFields
    }
    size {
      ...sizeFields
    }
    shipping {
      ...shippingFields
    }
    categories {
      ...categoriesFields
    }
    store {
      ...storeFields
    },
    variations {
      ...variationsFields
    },
    tags {
      ...tagsFields
    }
  }

  ${priceFields}
  ${sizeFields}
  ${categoriesFields}
  ${shippingFields}
  ${storeFields}
  ${variationsFields}
  ${tagsFields}
`
